import Loader from '@/components/loader';
import { TESTING, pages } from "@/Environment";
import SAMPLE_RESPONSE from "@/pages/view_grade/sample_analysis_results.json" with { type: "json" };
import ViewGrade from "@/pages/view_grade/ViewGrade";
import "@/styles/default.css";
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { normalizeAnalysis } from "@/lib/analysis-normalizer";
import { useAuth } from "@/contexts/AuthContext";

function ErrorPage({ error }) {
  return (
    <main className="min-h-screen bg-[var(--surface-ambient)] pt-32">
      <div className="mx-auto flex max-w-3xl flex-col gap-6 rounded-3xl border border-[rgba(31,76,84,0.12)] bg-white/90 p-12 text-center shadow-[0_24px_48px_rgba(15,23,42,0.08)]">
        <h1 className="font-display text-2xl font-semibold !tracking-display text-[var(--text-primary)]">{error}</h1>
        <p className="text-sm text-[var(--text-secondary)]">
          The analysis data could not be loaded. Please return to the upload page and try again.
        </p>
        <div className="flex justify-center">
          <Link to={pages.UPLOAD}>
            <Button size="sm">Return to upload</Button>
          </Link>
        </div>
      </div>
    </main>
  );
}

export default function ViewGradeWrapper() {
  const location = useLocation();
  const { isGuest } = useAuth();

  const [analysisData, setAnalysisData] = useState(null);
  const [error, setError] = useState(null);

  // Check if user was redirected from email verification
  const fromVerification = location.state?.fromVerification === true;

  useEffect(() => {
    let jsonData;

    if (TESTING) {
      jsonData = SAMPLE_RESPONSE;
    }
    else {
      let data = location.state?.data;
      if (!data) data = localStorage.getItem("analysisData");

      if (!data) {
        setError("No data was provided");
        return;
      }

      try {
        jsonData = JSON.parse(data);
      }
      catch {
        setError("The data provided was not valid JSON");
        return;
      }
    }

    const normalizedAnalysis = normalizeAnalysis(jsonData);

    localStorage.setItem("analysisData", JSON.stringify(normalizedAnalysis));
    setAnalysisData(normalizedAnalysis);
  }, []);

  if (error) return <ErrorPage error={error} />;

  if (!analysisData) {
    return (
      <main className="min-h-screen bg-[var(--surface-ambient)] pt-32">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-4 rounded-3xl border border-[rgba(31,76,84,0.12)] bg-white/85 p-12 text-center shadow-[0_24px_48px_rgba(15,23,42,0.08)]">
          <Loader />
          <p className="text-sm text-[var(--text-secondary)]">Preparing your analysis...</p>
        </div>
      </main>
    );
  }

  return (
    <ViewGrade
      analysisData={analysisData}
      isGuestView={isGuest}
      showWelcome={fromVerification && !isGuest}
    />
  );
}
